<script setup>
defineProps({
    selected: Boolean
})
</script>

<template>
    <div class=" border bg-white dark:bg-gray-900 dark:border-neutral-700 rounded-3xl overflow-hidden p-4 transition-all hover:shadow flex flex-col " :class="{ 'ring ring-offset-2': selected }">
        <slot name="image"></slot>

        <div class="overflow-ellipsis">
            <slot name="header"></slot>
        </div>

        <slot name="body"></slot>

        <div class="grow"></div>

        <div class="flex items-center gap-3 mt-4">
            <div class="border rounded-xl dark:border-neutral-700 p-1 flex items-center gap-3">
                <slot name="main-actions"></slot>
            </div>

            <div class="grow"></div>
            <slot name="secondary-actions"></slot>
        </div>
    </div>
</template>

<style scoped lang="scss">

</style>
